import styled from 'styled-components';
import classNames from 'classnames';
import { UiLinkProps } from '../ui-link';
import DotsLoader from '../../dots-loader';
import ActionLink from './action-link';

interface LoadingLinkProps extends UiLinkProps {
  isLoading?: boolean;
}

const StyledLoadingLink = styled(ActionLink)`
  position: relative;
  display: ${props => props.display || 'inline-block'};

  .link-spinner {
    position: absolute;
    right: -20px;
    top: 11px;
    margin-left: 8px;
  }
`;

const LoadingLink = ({ children, className, isLoading, disabled, ...rest }: LoadingLinkProps) => (
  <StyledLoadingLink className={classNames('box-loading-link', className)} disabled={disabled} {...rest}>
    {children}
    {isLoading && <DotsLoader className={'link-spinner'} size={'xxs'} variant={disabled ? 'gray400' : 'action'} />}
  </StyledLoadingLink>
);

LoadingLink.displayName = 'LoadingLink';
export default LoadingLink;
